import { render } from "./registerPage.vue?vue&type=template&id=1e5d6c8a&scoped=true"
import script from "./registerPage.vue?vue&type=script&lang=js"
export * from "./registerPage.vue?vue&type=script&lang=js"

import "./registerPage.vue?vue&type=style&index=0&id=1e5d6c8a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e5d6c8a"]])

export default __exports__